import { httpClient, unwrap, unwrapPaginated } from '@/services/httpClient';
import type {
  NotificationChannelSettings, NotificationEntry, NotificationLogEntry, NotificationPreference, NotificationTemplate,
} from '@/features/notifications/types';

export const notificationsApi = {
  list: (page = 1, perPage = 8) =>
    unwrapPaginated<NotificationEntry>(httpClient.get('/notifications', { params: { page, per_page: perPage } })),

  markRead: (id: number) => unwrap<{ id: number; is_read: boolean }>(httpClient.put(`/notifications/${id}/read`)),
  markAllRead: () => unwrap<{ message: string }>(httpClient.put('/notifications/read-all')),
  remove: (id: number) => unwrap<null>(httpClient.delete(`/notifications/${id}`)),

  preferences: () => unwrap<NotificationPreference[]>(httpClient.get('/notifications/preferences')),
  updatePreferences: (preferences: NotificationPreference[]) =>
    unwrap<NotificationPreference[]>(httpClient.put('/notifications/preferences', { preferences })),

  subscribeWeb: (payload: { endpoint: string; p256dh_key: string; auth_key: string }) =>
    unwrap<{ id: number }>(httpClient.post('/notifications/subscriptions/web', payload)),
  unsubscribeWeb: (endpoint: string) => unwrap<null>(httpClient.delete('/notifications/subscriptions/web', { data: { endpoint } })),

  templates: () => unwrap<NotificationTemplate[]>(httpClient.get('/notifications/templates')),
  saveTemplate: (payload: { event_key: string; channel: string; subject?: string; body_template: string }) =>
    unwrap<NotificationTemplate>(httpClient.post('/notifications/templates', payload)),
  deleteTemplate: (id: number) => unwrap<null>(httpClient.delete(`/notifications/templates/${id}`)),

  channelSettings: () => unwrap<NotificationChannelSettings>(httpClient.get('/notifications/channel-settings')),
  updateChannelSettings: (payload: Partial<{
    sms_provider: string; sms_account_sid: string; sms_auth_token: string; sms_from_number: string;
    whatsapp_phone_number_id: string; whatsapp_access_token: string; push_fcm_server_key: string;
  }>) => unwrap<NotificationChannelSettings>(httpClient.put('/notifications/channel-settings', payload)),

  logs: (page: number, filters?: { channel?: string; deliveryStatus?: string }) =>
    unwrapPaginated<NotificationLogEntry>(httpClient.get('/notifications/logs', {
      params: { page, per_page: 20, channel: filters?.channel, delivery_status: filters?.deliveryStatus },
    })),

  processQueue: () => unwrap<{ retried: number; recovered: number; gave_up: number }>(httpClient.post('/notifications/queue/process')),
};
